import { RestClient } from "./restClient";
import RestResponse from "@/models/client/RestResponse";
import RequestMethod from "@/models/client/RequestMethod";
import {
  SourceDef,
  SourceDictionary,
} from "@/models/legislation/LegislationFilter";

export type LegislationFilterServiceType = {
  getFilterConfiguration: () => RestResponse<SourceDictionary>;
  getSourcedFilterConfigarution: (source: string) => RestResponse<SourceDef>;
  getDefaultFilterConfiguration: () => RestResponse<SourceDictionary>;
};

const legislationFilterServices = (
  client: RestClient,
  path: string
): LegislationFilterServiceType => ({
  getFilterConfiguration: async () =>
    await client.fetch<{ sources: Record<string, SourceDef> }>(
      RequestMethod.GET,
      `${path}/filter-configuration`
    ),
  getSourcedFilterConfigarution: async (source: string) =>
    await client.fetch<SourceDef>(
      RequestMethod.GET,
      `${path}/filter-configuration/${source}`
    ),
  getDefaultFilterConfiguration: async () =>
    await client.fetch<{ sources: Record<string, SourceDef> }>(
      RequestMethod.GET,
      `${path}/filter-configuration/default`
    ),
});

export default legislationFilterServices;
